export default __webpack_public_path__ + "static/harvey-norman-horizontal-8df6b34ef1556f03ae72f4745ea68d8a.png";